module.exports = "//img1.rrcimg.com/_next/static/src/assets/down-app_2A8LV.png";